import { StoreLayout } from "../../components/StoreLayout";

const Section = ({ n, title, children }) => (
  <section className="mt-8" data-testid={`privacy-section-${n}`}>
    <h2 className="font-[Outfit] text-xl md:text-2xl font-bold text-[#1E293B]">{n}. {title}</h2>
    <div className="mt-2 space-y-3 text-[#475569] leading-relaxed text-[15px]">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <StoreLayout>
      <div className="bg-white border-b border-[#E2E8F0]">
        <div className="max-w-3xl mx-auto px-5 py-12">
          <p className="uppercase text-xs tracking-[0.2em] font-semibold text-[#4F46E5]">Legal</p>
          <h1 className="font-[Outfit] text-4xl md:text-5xl font-extrabold tracking-tight mt-2">Privacy Policy</h1>
          <p className="text-[#475569] mt-3">Last updated: June 2026</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-5 py-10">
        <p className="text-[#475569] leading-relaxed text-[15px]">
          Fixigo Home Services ("Fixigo", "we", "us") respects your privacy. This Privacy Policy explains what
          information we collect, how we use it, and the choices you have. It applies to our website and services
          offered in Mumbai, Pune and Bengaluru.
        </p>

        <Section n="1" title="Information We Collect">
          <p>We collect information you provide directly, such as your name, phone number, email address, service
          address, and booking details. For Partners, we additionally collect business details, GSTIN (if applicable),
          and uploaded identity/qualification documents. We also collect limited technical data (such as device and
          usage information) to operate and improve the website.</p>
        </Section>

        <Section n="2" title="How We Use Your Information">
          <p>We use your information to: confirm and fulfil service bookings; assign and coordinate Partners; process
          payments after service; provide customer support; send service updates and important notices; verify Partner
          eligibility; and improve our services. We may use feedback and ratings you submit to maintain service quality.</p>
        </Section>

        <Section n="3" title="Sharing With Partners &amp; Third Parties">
          <p>To deliver a service, we share necessary booking details (such as your name, address, contact number and
          service requirements) with the assigned Partner. We may use trusted third-party providers for storage,
          communications and analytics, who are required to protect your data. We do not sell your personal information.</p>
        </Section>

        <Section n="4" title="Payments">
          <p>Fixigo currently operates on a pay-after-service model. Where digital payments are introduced, payment
          information is handled by secure third-party payment processors; we do not store full card details on our
          servers.</p>
        </Section>

        <Section n="5" title="Data Storage &amp; Security">
          <p>Your information is stored on secured infrastructure and protected using reasonable technical and
          organisational measures, including encryption in transit. While we strive to protect your data, no method of
          transmission or storage is completely secure.</p>
        </Section>

        <Section n="6" title="Cookies">
          <p>We use cookies and similar technologies to keep you signed in, remember preferences, and understand how the
          website is used. You can control cookies through your browser settings, though some features may not function
          properly if disabled.</p>
        </Section>

        <Section n="7" title="Data Retention">
          <p>We retain personal information for as long as needed to provide our services, comply with legal obligations,
          resolve disputes and enforce our agreements. Partner verification documents are retained as required for
          compliance.</p>
        </Section>

        <Section n="8" title="Your Rights">
          <p>Subject to applicable law, you may request access to, correction of, or deletion of your personal
          information, and you may opt out of non-essential communications. To exercise these rights, contact us using
          the details below.</p>
        </Section>

        <Section n="9" title="Children's Privacy">
          <p>Our services are intended for users aged 18 and above. We do not knowingly collect personal information from
          children.</p>
        </Section>

        <Section n="10" title="Changes to this Policy">
          <p>We may update this Privacy Policy periodically. The latest version will be posted on this page with a
          revised "Last updated" date.</p>
        </Section>

        <Section n="11" title="Contact Us">
          <p>For any privacy-related questions or requests, contact us at <strong>support@fixigohomeservices.in</strong> or
          <strong> +91 91529 43297</strong> (call or WhatsApp).</p>
        </Section>
      </div>
    </StoreLayout>
  );
}
